import { render, staticRenderFns } from "./float-zhanghu-bangding.vue?vue&type=template&id=5ca5196f&"
import script from "./float-zhanghu-bangding.vue?vue&type=script&lang=js&"
export * from "./float-zhanghu-bangding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports